import { Flex } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';

import useEditBoardSettings from './useEditBoardSettings';
import NavigationGuard from '../../../shared/NavigationGuard';
import Tooltip from '../../../shared/Tooltip/Tooltip.jsx';
import SharingContent from './SharingSection/Sharing.jsx';
import UnsavedChangesModal from '../../../shared/UnsavedChangesModal';
import { Button as FormButton } from '../../../shared/FormStyles';
import SectionCard from '../../../shared/SectionCard/SectionCard.jsx';

const Sharing = () => {
  const {
    handleChange,
    values,
    handleSubmit,
    disabledSubmit,
    setFieldValue,
    resetForm,
    inputError,
    handleBlur,
    setFieldError,
    setFieldTouched,
    dirty,
    showUnsavedChangesModal,
    setShowUnsavedChangesModal,
    setPendingAction,
    handleCloseModal,
    handleDiscardChanges,
    handleSaveAndLeave,
  } = useEditBoardSettings();
  const { t } = useTranslation(['shared', 'boardSetup']);

  return (
    <NavigationGuard
      hasUnsavedChanges={dirty}
      showUnsavedChangesModal={showUnsavedChangesModal}
      setShowUnsavedChangesModal={setShowUnsavedChangesModal}
      setPendingAction={setPendingAction}
    >
      <Tooltip />
      <SectionCard title={t('boardSetup:sharing.title')}>
        <Flex direction="column" gap="4" py="4">
          <SharingContent
            handleChange={handleChange}
            handleBlur={handleBlur}
            demo={values}
            inputError={inputError}
            setFieldValue={setFieldValue}
            setFieldError={setFieldError}
            setFieldTouched={setFieldTouched}
          />
          <Flex justify="end" gap="3">
            <FormButton variant="tertiary" onClick={resetForm}>
              {t('shared:cancel')}
            </FormButton>
            <FormButton
              ml="8px"
              variant="containedBlue"
              disabled={disabledSubmit}
              onClick={handleSubmit}
              type="submit"
            >
              {t('shared:save')}
            </FormButton>
          </Flex>
        </Flex>
      </SectionCard>
      <UnsavedChangesModal
        isOpen={showUnsavedChangesModal}
        onClose={handleCloseModal}
        onDiscard={handleDiscardChanges}
        onSave={handleSaveAndLeave}
      />
    </NavigationGuard>
  );
};

export default Sharing;
